import React from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

const CardGenericSkeleton: React.FC<React.SVGAttributes<SVGElement> & IContentLoaderProps> =
  function (props) {
    return (
      <ContentLoader
        speed={1.5}
        width="100%"
        viewBox="0 0 400 617"
        backgroundColor="#f8f8f8"
        foregroundColor="#EAEAEA"
        {...props}
      >
        <path d="M381.961 416H3.03947C1.36082 416 0 418.388 0 421.333V442.667C0 445.612 1.36082 448 3.03947 448H381.961C383.639 448 385 445.612 385 442.667V421.333C385 418.388 383.639 416 381.961 416Z" />
        <path d="M282.75 459H2.25C1.00736 459 0 461.388 0 464.333V485.667C0 488.612 1.00736 491 2.25 491H282.75C283.993 491 285 488.612 285 485.667V464.333C285 461.388 283.993 459 282.75 459Z" />
        <rect width="400" height="400" rx="15" />
      </ContentLoader>
    );
  };

export default CardGenericSkeleton;
